<h2>{{formLabels['title']}}: {{form1.value.adrDevelopmentName}}</h2>

<form [formGroup]="form1">
  <mat-tab-group>
    <mat-tab label="Settings">
      <mat-tab-group>
        <mat-tab label="Overview">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-12">
                <h2>Overview</h2>
              </div>
              <div class="col-lg-6">
                <mat-form-field class="block">
                  <mat-label>listingStatus</mat-label>
                  <mat-select formControlName="listingStatus">
                    @for (stat of listingStatuses; track stat) {
                      <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                    }
                  </mat-select>
                  @for (validation of validationMessages.listingStatus; track validation) {
                    <mat-error>
                      @if (form1.get('listingStatus').hasError(validation.type) && (form1.get('listingStatus').dirty || form1.get('listingStatus').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-lg-6">
                <mat-form-field class="block">
                  <mat-label>Development Name</mat-label>
                  <input matInput formControlName="adrDevelopmentName" [readonly]="formReadOnly">
                  @for (validation of validationMessages.adrDevelopmentName; track validation) {
                    <mat-error>
                      @if (form1.get('adrDevelopmentName').hasError(validation.type) && (form1.get('adrDevelopmentName').dirty || form1.get('adrDevelopmentName').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="block">
                  <mat-label>Development Code</mat-label>
                  <input matInput formControlName="propertyCode" [readonly]="formReadOnly">
                  @for (validation of validationMessages.propertyCode; track validation) {
                    <mat-error>
                      @if (form1.get('propertyCode').hasError(validation.type) && (form1.get('propertyCode').dirty || form1.get('propertyCode').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="block">
                  <mat-label>Highest Floor</mat-label>
                  <input matInput formControlName="floorsTotal" [readonly]="formReadOnly">
                  @for (validation of validationMessages.floorsTotal; track validation) {
                    <mat-error>
                      @if (form1.get('floorsTotal').hasError(validation.type) && (form1.get('floorsTotal').dirty || form1.get('floorsTotal').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="block">
                  <mat-label>Total Buildings</mat-label>
                  <input matInput formControlName="buildingsTotal" [readonly]="formReadOnly">
                  @for (validation of validationMessages.buildingsTotal; track validation) {
                    <mat-error>
                      @if (form1.get('buildingsTotal').hasError(validation.type) && (form1.get('buildingsTotal').dirty || form1.get('buildingsTotal').touched)) {
                        <mat-error class="error-message"
                          >
                          {{validation.message}}
                        </mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field>
                  <mat-label>Total Units</mat-label>
                  <input matInput formControlName="unitsTotal" [readonly]="formReadOnly">
                  @for (validation of validationMessages.unitsTotal; track validation) {
                    <mat-error>
                      @if (form1.get('unitsTotal').hasError(validation.type) && (form1.get('unitsTotal').dirty || form1.get('unitsTotal').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="block">
                  <mat-label>Year Built</mat-label>
                  <input matInput formControlName="yearBuilt" [readonly]="formReadOnly">
                  @for (validation of validationMessages.yearBuilt; track validation) {
                    <mat-error>
                      @if (form1.get('yearBuilt').hasError(validation.type) && (form1.get('yearBuilt').dirty || form1.get('yearBuilt').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-lg-3">
                <mat-form-field class="block">
                  <mat-label>Total Development Lot Size</mat-label>
                  <input matInput formControlName="sizeLot" [readonly]="formReadOnly">
                  @for (validation of validationMessages.sizeLot; track validation) {
                    <mat-error>
                      @if (form1.get('sizeLot').hasError(validation.type) && (form1.get('sizeLot').dirty || form1.get('sizeLot').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-lg-3">
                <mat-form-field class="block">
                  <mat-label>sizeUnitOfMeasurement</mat-label>
                  <mat-select formControlName="sizeUnitOfMeasurement">
                    @for (stat of sizeUnitOfMeasurements; track stat) {
                      <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                    }
                  </mat-select>
                  @for (validation of validationMessages.sizeUnitOfMeasurement; track validation) {
                    <mat-error>
                      @if (form1.get('sizeUnitOfMeasurement').hasError(validation.type) && (form1.get('sizeUnitOfMeasurement').dirty || form1.get('sizeUnitOfMeasurement').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-lg-6">
                <mat-form-field class="block">
                  <mat-label>Key Service Type</mat-label>
                  <mat-select formControlName="keyServiceType">
                    @for (stat of keyServiceTypes; track stat) {
                      <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                    }
                  </mat-select>
                  @for (validation of validationMessages.keyServiceType; track validation) {
                    <mat-error>
                      @if (form1.get('keyServiceType').hasError(validation.type) && (form1.get('keyServiceType').dirty || form1.get('keyServiceType').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-lg-6">
                <mat-slide-toggle class="block" formControlName="showDevelopmentOnline">Show Development Online</mat-slide-toggle>
              </div>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Financials">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-12">
                <h2>Financials</h2>
              </div>
              <div class="col-lg-12">
                <mat-form-field class="col-lg-12">
                  <mat-label>Parking Fee</mat-label> <input matInput formControlName="parkingFee" [readonly]="formReadOnly">
                  @for (validation of validationMessages.parkingFee; track validation) {
                    <mat-error>
                      @if (form1.get('parkingFee').hasError(validation.type) && (form1.get('parkingFee').dirty || form1.get('parkingFee').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Address">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-12">
                <h2>Address</h2>
              </div>
              <div class="col">
                <mat-form-field class="block">
                  <mat-label>Street #</mat-label>
                  <input matInput formControlName="adrStreetNumber" [readonly]="formReadOnly">
                  @for (validation of validationMessages.adrStreetNumber; track validation) {
                    <mat-error>
                      @if (form1.get('adrStreetNumber').hasError(validation.type) && (form1.get('adrStreetNumber').dirty || form1.get('adrStreetNumber').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-8">
                <mat-form-field class="block">
                  <mat-label>Street Name</mat-label>
                  <input matInput formControlName="adrStreetName" [readonly]="formReadOnly">
                  @for (validation of validationMessages.adrStreetName; track validation) {
                    <mat-error>
                      @if (form1.get('adrStreetName').hasError(validation.type) && (form1.get('adrStreetName').dirty || form1.get('adrStreetName').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="block">
                  <mat-label>Unit #</mat-label>
                  <input matInput formControlName="adrUnit" [readonly]="formReadOnly">
                  @for (validation of validationMessages.adrUnit; track validation) {
                    <mat-error>
                      @if (form1.get('adrUnit').hasError(validation.type) && (form1.get('adrUnit').dirty || form1.get('adrUnit').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-lg-12">
                <mat-form-field class="block">
                  <mat-label>Address 2</mat-label>
                  <input matInput formControlName="adr2" [readonly]="formReadOnly">
                  @for (validation of validationMessages.adr2; track validation) {
                    <mat-error>
                      @if (form1.get('adr2').hasError(validation.type) && (form1.get('adr2').dirty || form1.get('adr2').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-5">
                <mat-form-field class="block">
                  <mat-label>City</mat-label> <input matInput formControlName="adrCity" [readonly]="formReadOnly">
                  @for (validation of validationMessages.adrCity; track validation) {
                    <mat-error>
                      @if (form1.get('adrCity').hasError(validation.type) && (form1.get('adrCity').dirty || form1.get('adrCity').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-5">
                <mat-form-field class="block">
                  <mat-label>State</mat-label> <input matInput formControlName="adrState" [readonly]="formReadOnly">
                  @for (validation of validationMessages.adrState; track validation) {
                    <mat-error>
                      @if (form1.get('adrState').hasError(validation.type) && (form1.get('adrState').dirty || form1.get('adrState').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="block">
                  <mat-label>Postal Code</mat-label> <input matInput formControlName="adrPostalCode" [readonly]="formReadOnly">
                  @for (validation of validationMessages.adrPostalCode; track validation) {
                    <mat-error>
                      @if (form1.get('adrPostalCode').hasError(validation.type) && (form1.get('adrPostalCode').dirty || form1.get('adrPostalCode').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="block">
                  <mat-label>County</mat-label>
                  <input matInput formControlName="adrCounty" [readonly]="formReadOnly">
                  @for (validation of validationMessages.adrCounty; track validation) {
                    <mat-error>
                      @if (form1.get('adrCounty').hasError(validation.type) && (form1.get('adrCounty').dirty || form1.get('adrCounty').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="block">
                  <mat-label>Country</mat-label>
                  <mat-select formControlName="adrCountry">
                    @for (stat of countries; track stat) {
                      <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                    }
                  </mat-select>
                  @for (validation of validationMessages.adrCountry; track validation) {
                    <mat-error>
                      @if (form1.get('adrCountry').hasError(validation.type) && (form1.get('adrCountry').dirty || form1.get('adrCountry').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-lg-12">
                <h3>Location</h3>
              </div>

              <div class="col-6">
                <mat-form-field class="block">
                  <mat-label>Building</mat-label>
                  <input matInput formControlName="adrBuildingName" [readonly]="formReadOnly">
                  @for (validation of validationMessages.adrBuildingName; track validation) {
                    <mat-error>
                      @if (form1.get('adrBuildingName').hasError(validation.type) && (form1.get('adrBuildingName').dirty || form1.get('adrBuildingName').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="block">
                  <mat-label>Complex</mat-label>
                  <input matInput formControlName="adrComplexName" [readonly]="formReadOnly">
                  @for (validation of validationMessages.adrComplexName; track validation) {
                    <mat-error>
                      @if (form1.get('adrComplexName').hasError(validation.type) && (form1.get('adrComplexName').dirty || form1.get('adrComplexName').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="block">
                  <mat-label>District</mat-label>
                  <input matInput formControlName="adrDistrictName" [readonly]="formReadOnly">
                  @for (validation of validationMessages.adrDistrictName; track validation) {
                    <mat-error>
                      @if (form1.get('adrDistrictName').hasError(validation.type) && (form1.get('adrDistrictName').dirty || form1.get('adrDistrictName').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="block">
                  <mat-label>Metro</mat-label>
                  <input matInput formControlName="adrMetro" [readonly]="formReadOnly">
                  @for (validation of validationMessages.adrMetro; track validation) {
                    <mat-error>
                      @if (form1.get('adrMetro').hasError(validation.type) && (form1.get('adrMetro').dirty || form1.get('adrMetro').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="block">
                  <mat-label>Region</mat-label>
                  <input matInput formControlName="adrRegion" [readonly]="formReadOnly">
                  @for (validation of validationMessages.adrRegion; track validation) {
                    <mat-error>
                      @if (form1.get('adrRegion').hasError(validation.type) && (form1.get('adrRegion').dirty || form1.get('adrRegion').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="block">
                  <mat-label>Island</mat-label>
                  <input matInput formControlName="adrIsland" [readonly]="formReadOnly">
                  @for (validation of validationMessages.adrIsland; track validation) {
                    <mat-error>
                      @if (form1.get('adrIsland').hasError(validation.type) && (form1.get('adrIsland').dirty || form1.get('adrIsland').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-md-6 col-lg-6">
                <mat-form-field class="w-100">
                  <mat-label>Location</mat-label>
                  <mat-select formControlName="locationId">
                    @for (stat of locations; track stat) {
                      <mat-option [value]="stat.locationId"> {{stat.name}}
                      </mat-option>
                    }
                  </mat-select>
                  @for (validation of validationMessages.locationId; track validation) {
                    <mat-error>
                      @if (form1.get('locationId').hasError(validation.type) && (form1.get('locationId').dirty || form1.get('locationId').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-12">
                <h3 style="flex: 0 0 100%">Reference</h3>
              </div>
              <div class="col-12">
                <mat-form-field class="block">
                  <mat-label>Cross Street</mat-label>
                  <input matInput formControlName="adrCrossStreet" [readonly]="formReadOnly">
                  @for (validation of validationMessages.adrCrossStreet; track validation) {
                    <mat-error>
                      @if (form1.get('adrCrossStreet').hasError(validation.type) && (form1.get('adrCrossStreet').dirty || form1.get('adrCrossStreet').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="block">
                  <mat-label>Longitude</mat-label>
                  <input matInput formControlName="adrLongitude" [readonly]="formReadOnly">
                  @for (validation of validationMessages.adrLongitude; track validation) {
                    <mat-error>
                      @if (form1.get('adrLongitude').hasError(validation.type) && (form1.get('adrLongitude').dirty || form1.get('adrLongitude').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="block">
                  <mat-label>Latitude</mat-label>
                  <input matInput formControlName="adrLatitude" [readonly]="formReadOnly">
                  @for (validation of validationMessages.adrLatitude; track validation) {
                    <mat-error>
                      @if (form1.get('adrLatitude').hasError(validation.type) && (form1.get('adrLatitude').dirty || form1.get('adrLatitude').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Marketing">
          <div class="container-fluid">
            <div class="row">
              <div class="col-12">
                <h2>Marketing</h2>
              </div>
              <div class="col-6">
                <mat-form-field class="block">
                  <mat-label>Rental United Building #</mat-label>
                  <input matInput formControlName="ruBuildingId" [readonly]="formReadOnly">
                  @for (validation of validationMessages.ruBuildingId; track validation) {
                    <mat-error>
                      @if (form1.get('ruBuildingId').hasError(validation.type) && (form1.get('ruBuildingId').dirty || form1.get('ruBuildingId').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-6">
                <mat-form-field class="block">
                  <mat-label>Locale</mat-label>
                  <mat-select formControlName="locale">
                    @for (stat of locales; track stat) {
                      <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                    }
                  </mat-select>
                  @for (validation of validationMessages.locale; track validation) {
                    <mat-error>
                      @if (form1.get('locale').hasError(validation.type) && (form1.get('locale').dirty || form1.get('locale').touched)) {
                        <mat-error class="error-message">
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Operations">
          <div class="container-fluid">
            <div class="row">
              <div class="col-12">
                <h2>Access Codes (default)</h2>
              </div>
              <div class="col">
                <mat-form-field class="block">
                  <mat-label>Front Door</mat-label>
                  <input matInput formControlName="codeFrontDoor" [readonly]="formReadOnly">
                  @for (validation of validationMessages.codeFrontDoor; track validation) {
                    <mat-error>
                      @if (form1.get('codeFrontDoor').hasError(validation.type) && (form1.get('codeFrontDoor').dirty || form1.get('codeFrontDoor').touched)) {
                        <mat-error class="error-message"
                          >
                          {{validation.message}}
                        </mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="block">
                  <mat-label>Garage Code</mat-label>
                  <input matInput formControlName="codeGarage" [readonly]="formReadOnly">
                  @for (validation of validationMessages.codeGarage; track validation) {
                    <mat-error>
                      @if (form1.get('codeGarage').hasError(validation.type) && (form1.get('codeGarage').dirty || form1.get('codeGarage').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="block">
                  <mat-label>Code Gate</mat-label>
                  <input matInput formControlName="codeGate" [readonly]="formReadOnly">
                  @for (validation of validationMessages.codeGate; track validation) {
                    <mat-error>
                      @if (form1.get('codeGate').hasError(validation.type) && (form1.get('codeGate').dirty || form1.get('codeGate').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="block">
                  <mat-label>HOA Gate Code</mat-label>
                  <input matInput formControlName="codeHoaGate" [readonly]="formReadOnly">
                  @for (validation of validationMessages.codeHoaGate; track validation) {
                    <mat-error>
                      @if (form1.get('codeHoaGate').hasError(validation.type) && (form1.get('codeHoaGate').dirty || form1.get('codeHoaGate').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="block">
                  <mat-label>Pool Code</mat-label>
                  <input matInput formControlName="codePool" [readonly]="formReadOnly">
                  @for (validation of validationMessages.codePool; track validation) {
                    <mat-error>
                      @if (form1.get('codePool').hasError(validation.type) && (form1.get('codePool').dirty || form1.get('codePool').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="block">
                  <mat-label>Recreation Room Code</mat-label>
                  <input matInput formControlName="codeRecreation" [readonly]="formReadOnly">
                  @for (validation of validationMessages.codeRecreation; track validation) {
                    <mat-error>
                      @if (form1.get('codeRecreation').hasError(validation.type) && (form1.get('codeRecreation').dirty || form1.get('codeRecreation').touched)) {
                        <mat-error class="error-message"
                          >
                          {{validation.message}}
                        </mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-12">
                <h2 style="flex: 0 0 100%">Misc</h2>
              </div>
              <div class="col">
                <mat-form-field class="block">
                  <mat-label>Location Type</mat-label>
                  <input matInput formControlName="loacationType" [readonly]="formReadOnly">
                  @for (validation of validationMessages.loacationType; track validation) {
                    <mat-error>
                      @if (form1.get('loacationType').hasError(validation.type) && (form1.get('loacationType').dirty || form1.get('loacationType').touched)) {
                        <mat-error class="error-message"
                          >
                          {{validation.message}}
                        </mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="block">
                  <mat-label>Paying Guest Booking Alert Email</mat-label>
                  <input matInput formControlName="newReservationAlertEmail" [readonly]="formReadOnly">
                  @for (validation of validationMessages.newReservationAlertEmail; track validation) {
                    <mat-error>
                      @if (form1.get('newReservationAlertEmail').hasError(validation.type) && (form1.get('newReservationAlertEmail').dirty || form1.get('newReservationAlertEmail').touched)) {
                        <mat-error class="error-message"
                          >
                          {{validation.message}}
                        </mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="block">
                  <mat-label>Owner Guest Reservation Alert Email</mat-label>
                  <input matInput formControlName="newOwnerGuestReservationAlertEmail" [readonly]="formReadOnly">
                  @for (validation of validationMessages.newOwnerGuestReservationAlertEmail; track validation) {
                    <mat-error>
                      @if (form1.get('newOwnerGuestReservationAlertEmail').hasError(validation.type) && (form1.get('newOwnerGuestReservationAlertEmail').dirty || form1.get('newOwnerGuestReservationAlertEmail').touched)) {
                        <mat-error class="error-message"
                          >
                          {{validation.message}}
                        </mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="block">
                  <mat-label>Owner Reservation Alert Email</mat-label>
                  <input matInput formControlName="newOwnerReservationAlertEmail" [readonly]="formReadOnly">
                  @for (validation of validationMessages.newOwnerReservationAlertEmail; track validation) {
                    <mat-error>
                      @if (form1.get('newOwnerReservationAlertEmail').hasError(validation.type) && (form1.get('newOwnerReservationAlertEmail').dirty || form1.get('newOwnerReservationAlertEmail').touched)) {
                        <mat-error class="error-message"
                          >
                          {{validation.message}}
                        </mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>
        </mat-tab>
        <!-- <mat-tab label="Compendium">
        <div class="container-fluid">
          <div class="col-md-12 col-lg-12">
            <label for="developmentCompendium"><strong>Compendium :</strong></label>
            <span class="p-float-label w-100 mb-3">
              <editor formControlName="developmentCompendium" id="txtHighlight"
								[init]="{
													  height: 500,
													  base_url: '/tinymce',
													  suffix: '.min',
													  plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
								toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}">
              </editor>
              <span *ngFor="let validation of validationMessages.developmentCompendium">
                <small class="p-invalid"
                  *ngIf="form1.get('developmentCompendium').hasError(validation.type) && (form1.get('developmentCompendium').dirty || form1.get('developmentCompendium').touched)">{{validation.message}}
                </small>
              </span>
            </span>
          </div>
        </div>
      </mat-tab> -->
    </mat-tab-group>
  </mat-tab>

  <mat-tab label="Descriptions">
    <mat-tab-group>
      <mat-tab label="Marketing">
        <br/>
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-12">
              <h3 class="block">Website Key Words (SEO)</h3>
              <mat-form-field class="block">
                <mat-label>Website Key Words (SEO)</mat-label>
                <textarea matInput formControlName="propDescShortKeyWords" [readonly]="formReadOnly"
                  matTextareaAutosize matAutosizeMinRows="3" matAutosizeMaxRows="50"
                matTooltip="Enter seo terms separated by commas."></textarea>
                @for (validation of validationMessages.propDescShortKeyWords; track validation) {
                  <mat-error>
                    @if (form1.get('propDescShortKeyWords').hasError(validation.type) && (form1.get('propDescShortKeyWords').dirty || form1.get('propDescShortKeyWords').touched)) {
                      <mat-error class="error-message"
                        >
                        {{validation.message}}
                      </mat-error>
                    }
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="col-lg-12">
              <h3 class="block">Development Description (Short)</h3>
              <mat-form-field class="block">
                <mat-label>Short Desc</mat-label>
                <textarea matInput formControlName="propDescShort" [readonly]="formReadOnly" matTextareaAutosize matAutosizeMinRows="15" matAutosizeMaxRows="500"
                matTooltip="Enter propDescShort, paragrphs are ok." rows="5"></textarea>
                @for (validation of validationMessages.propDescShort; track validation) {
                  <mat-error>
                    @if (form1.get('propDescShort').hasError(validation.type) && (form1.get('propDescShort').dirty || form1.get('propDescShort').touched)) {
                      <mat-error class="error-message"
                        >
                        {{validation.message}}
                      </mat-error>
                    }
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <br>
              <div class="col-lg-12">
                <h3 class="block">Development Description (Long)</h3>
                <mat-form-field class="block">
                  <mat-label>Long Desc</mat-label>
                  <textarea matInput formControlName="propDesc" [readonly]="formReadOnly" matTextareaAutosize matAutosizeMinRows="15" matAutosizeMaxRows="500"
                  matTooltip="Enter propDesc, paragrphs are ok." rows="5"></textarea>
                  @for (validation of validationMessages.propDesc; track validation) {
                    <mat-error>
                      @if (form1.get('propDesc').hasError(validation.type) && (form1.get('propDesc').dirty || form1.get('propDesc').touched)) {
                        <mat-error class="error-message">
                          {{validation.message}}
                        </mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <br>
                <div class="col-lg-12">
                  <h3 class="block">Prop Tagline (Short)</h3>
                  <mat-form-field class="block">
                    <mat-label>Prop Tagline</mat-label>
                    <textarea matInput formControlName="propTagline" [readonly]="formReadOnly" matTextareaAutosize matAutosizeMinRows="15" matAutosizeMaxRows="500"
                    matTooltip="Enter propTagline, paragrphs are ok." rows="5"></textarea>
                    @for (validation of validationMessages.propTagline; track validation) {
                      <mat-error>
                        @if (form1.get('propTagline').hasError(validation.type) && (form1.get('propTagline').dirty || form1.get('propTagline').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}
                          </mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <br>
                  <div class="col-lg-12">
                    <h3 class="block">Location Description</h3>
                    <mat-form-field class="block">
                      <mat-label>Location</mat-label>
                      <textarea matInput formControlName="loacationDesc" [readonly]="formReadOnly" matTextareaAutosize matAutosizeMinRows="15" matAutosizeMaxRows="500"
                      matTooltip="Enter loacationDesc, paragrphs are ok." rows="5"></textarea>
                      @for (validation of validationMessages.loacationDesc; track validation) {
                        <mat-error>
                          @if (form1.get('loacationDesc').hasError(validation.type) && (form1.get('loacationDesc').dirty || form1.get('loacationDesc').touched)) {
                            <mat-error class="error-message"
                              >
                              {{validation.message}}
                            </mat-error>
                          }
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <br>
                    <div class="col-lg-12">
                      <h3 class="block">Features Description</h3>
                      <mat-form-field class="block">
                        <mat-label>Features</mat-label>
                        <textarea matInput formControlName="featureDesc" [readonly]="formReadOnly" matTextareaAutosize matAutosizeMinRows="15" matAutosizeMaxRows="500"
                        matTooltip="Enter featureDesc, paragrphs are ok." rows="5"></textarea>
                        @for (validation of validationMessages.featureDesc; track validation) {
                          <mat-error>
                            @if (form1.get('featureDesc').hasError(validation.type) && (form1.get('featureDesc').dirty || form1.get('featureDesc').touched)) {
                              <mat-error class="error-message">
                                {{validation.message}}
                              </mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <br>
                      <div class="col-lg-12">
                        <h3 class="block">Access Description</h3>
                        <mat-form-field class="block">
                          <mat-label>Access</mat-label>
                          <textarea matInput formControlName="accessDesc" [readonly]="formReadOnly" matTextareaAutosize matAutosizeMinRows="15" matAutosizeMaxRows="500"
                          matTooltip="Enter accessDesc, paragrphs are ok." rows="5"></textarea>
                          @for (validation of validationMessages.accessDesc; track validation) {
                            <mat-error>
                              @if (form1.get('accessDesc').hasError(validation.type) && (form1.get('accessDesc').dirty || form1.get('accessDesc').touched)) {
                                <mat-error class="error-message">
                                  {{validation.message}}
                                </mat-error>
                              }
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <br>
                        <div class="col-lg-12">
                          <h3 class="block">Disabled Description</h3>
                          <mat-form-field class="block">
                            <mat-label>Disabled</mat-label>
                            <textarea matInput formControlName="disabledDesc" [readonly]="formReadOnly" matTextareaAutosize matAutosizeMinRows="15" matAutosizeMaxRows="500"
                            matTooltip="Enter disabledDesc, paragrphs are ok." rows="5"></textarea>
                            @for (validation of validationMessages.disabledDesc; track validation) {
                              <mat-error>
                                @if (form1.get('disabledDesc').hasError(validation.type) && (form1.get('disabledDesc').dirty || form1.get('disabledDesc').touched)) {
                                  <mat-error class="error-message">
                                    {{validation.message}}
                                  </mat-error>
                                }
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <br>
                          <div class="col-lg-12">
                            <h3 class="block">Pets Description</h3>
                            <mat-form-field class="block">
                              <mat-label>Pets</mat-label>
                              <textarea matInput formControlName="petsDesc" [readonly]="formReadOnly" matTextareaAutosize matAutosizeMinRows="15" matAutosizeMaxRows="500"
                              matTooltip="Enter petsDesc, paragrphs are ok." rows="5"></textarea>
                              @for (validation of validationMessages.petsDesc; track validation) {
                                <mat-error>
                                  @if (form1.get('petsDesc').hasError(validation.type) && (form1.get('petsDesc').dirty || form1.get('petsDesc').touched)) {
                                    <mat-error class="error-message">
                                      {{validation.message}}
                                    </mat-error>
                                  }
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                          <br>
                            <div class="col-lg-12">
                              <h3 class="block">Parking Description</h3>
                              <mat-form-field class="block">
                                <mat-label>Parking Description</mat-label>
                                <textarea matInput formControlName="parkingDesc" [readonly]="formReadOnly" matTextareaAutosize matAutosizeMinRows="15" matAutosizeMaxRows="500"
                                matTooltip="Enter parkingDesc, paragrphs are ok." rows="5"></textarea>
                                @for (validation of validationMessages.parkingDesc; track validation) {
                                  <mat-error>
                                    @if (form1.get('parkingDesc').hasError(validation.type) && (form1.get('parkingDesc').dirty || form1.get('parkingDesc').touched)) {
                                      <mat-error class="error-message">
                                        {{validation.message}}
                                      </mat-error>
                                    }
                                  </mat-error>
                                }
                              </mat-form-field>
                            </div>
                            <br>
                              <div class="col-lg-12">
                                <h3 class="block">Parking Fees</h3>
                                <mat-form-field class="block">
                                  <mat-label>Parking Fees</mat-label>
                                  <textarea matInput formControlName="parkingFeeDesc" [readonly]="formReadOnly" matTextareaAutosize matAutosizeMinRows="15" matAutosizeMaxRows="500"
                                  matTooltip="Enter parkingFeeDesc, paragrphs are ok." rows="5"></textarea>
                                  @for (validation of validationMessages.parkingFeeDesc; track validation) {
                                    <mat-error>
                                      @if (form1.get('parkingFeeDesc').hasError(validation.type) && (form1.get('parkingFeeDesc').dirty || form1.get('parkingFeeDesc').touched)) {
                                        <mat-error class="error-message"
                                          >
                                          {{validation.message}}
                                        </mat-error>
                                      }
                                    </mat-error>
                                  }
                                </mat-form-field>
                              </div>
                              <br>
                                <div class="col-lg-12">
                                  <h3 class="block">Directions To Property</h3>
                                  <mat-form-field class="block">
                                    <mat-label>Directions To Property</mat-label>
                                    <textarea matInput formControlName="directionsToProperty" [readonly]="formReadOnly" matTextareaAutosize matAutosizeMinRows="15" matAutosizeMaxRows="500"
                                    matTooltip="Maintenance issues printed in contract AND website AND marketing" rows="5"></textarea>
                                    @for (validation of validationMessages.directionsToProperty; track validation) {
                                      <mat-error>
                                        @if (form1.get('directionsToProperty').hasError(validation.type) && (form1.get('directionsToProperty').dirty || form1.get('directionsToProperty').touched)) {
                                          <mat-error class="error-message"
                                            >
                                            {{validation.message}}
                                          </mat-error>
                                        }
                                      </mat-error>
                                    }
                                  </mat-form-field>
                                </div>

                                <div class="col-lg-12">
                                  <h3 class="block">Arrival Instructions</h3>
                                  <mat-form-field class="block">
                                    <mat-label>Directions To Property</mat-label>
                                    <textarea matInput formControlName="arrivalInstructionsDesc" [readonly]="formReadOnly" matTextareaAutosize matAutosizeMinRows="15" matAutosizeMaxRows="500"
                                    matTooltip="Detailed arrival instructions" rows="5"></textarea>
                                    @for (validation of validationMessages.arrivalInstructionsDesc; track validation) {
                                      <mat-error>
                                        @if (form1.get('arrivalInstructionsDesc').hasError(validation.type) && (form1.get('arrivalInstructionsDesc').dirty || form1.get('arrivalInstructionsDesc').touched)) {
                                          <mat-error class="error-message"
                                            >
                                            {{validation.message}}
                                          </mat-error>
                                        }
                                      </mat-error>
                                    }
                                  </mat-form-field>
                                </div>
                              </div>
                            </div>

                            <br><br>
                            <div class="container-fluid">
                              <div class="row">
                                <div class="col-lg-12">
                                  <app-feature-list style="flex: 0 0 calc(100%-10px)" [featuresList]="featuresList" title="Parking" [developmentId]="developmentId" featureType="parking" describesType=""></app-feature-list><br><br>
                                </div>
                              </div>
                            </div>
                          </mat-tab>

                          <mat-tab label="Contract">
                            <br>
                              <div class="container-fluid">
                                <div class="row">
                                  <div class="col-lg-12">
                                    <h3 class="block">Global Terms</h3>
                                    <mat-form-field class="block">
                                      <mat-label>Marketing Terms</mat-label>
                                      <textarea matInput formControlName="termsDesc" [readonly]="formReadOnly" matTextareaAutosize matAutosizeMinRows="15" matAutosizeMaxRows="500"
                                      matTooltip="Terms are printed in contract AND website AND marketing"></textarea>
                                      @for (validation of validationMessages.termsDesc; track validation) {
                                        <mat-error>
                                          @if (form1.get('termsDesc').hasError(validation.type) && (form1.get('termsDesc').dirty || form1.get('termsDesc').touched)) {
                                            <mat-error class="error-message">
                                              {{validation.message}}
                                            </mat-error>
                                          }
                                        </mat-error>
                                      }
                                    </mat-form-field>
                                  </div>
                                  <br>
                                    <div class="col-lg-12">
                                      <h3 class="block">Contract Terms</h3>
                                      <mat-form-field class="block">
                                        <mat-label>Contract Terms</mat-label>
                                        <textarea matInput formControlName="contractTerms" [readonly]="formReadOnly" matTextareaAutosize matAutosizeMinRows="15" matAutosizeMaxRows="500"
                                        matTooltip="Contract Terms are printed ONLY in contract"></textarea>
                                        @for (validation of validationMessages.contractTerms; track validation) {
                                          <mat-error>
                                            @if (form1.get('contractTerms').hasError(validation.type) && (form1.get('contractTerms').dirty || form1.get('contractTerms').touched)) {
                                              <mat-error class="error-message">
                                                {{validation.message}}
                                              </mat-error>
                                            }
                                          </mat-error>
                                        }
                                      </mat-form-field>
                                    </div>
                                  </div>
                                </div>
                              </mat-tab>
                              <br>
                                <mat-tab label="Maintenance">
                                  <br>
                                    <div class="container-fluid">
                                      <div class="row">
                                        <div class="col-lg-12">
                                          <h3 class="block">Maintenance Issues & Updates</h3>
                                          <mat-form-field class="block">
                                            <mat-label>Maintenance Issues & Updates</mat-label>
                                            <textarea matInput formControlName="maintenanceIssuesDesc" [readonly]="formReadOnly" matTextareaAutosize matAutosizeMinRows="15" matAutosizeMaxRows="500"
                                            matTooltip="Maintenance issues printed in contract AND website AND marketing"></textarea>
                                            @for (validation of validationMessages.maintenanceIssuesDesc; track validation) {
                                              <mat-error>
                                                @if (form1.get('maintenanceIssuesDesc').hasError(validation.type) && (form1.get('maintenanceIssuesDesc').dirty || form1.get('maintenanceIssuesDesc').touched)) {
                                                  <mat-error class="error-message"
                                                    >
                                                    {{validation.message}}
                                                  </mat-error>
                                                }
                                              </mat-error>
                                            }
                                          </mat-form-field>
                                        </div>
                                      </div>
                                    </div>
                                  </mat-tab>
                                </mat-tab-group>
                              </mat-tab>


                              <mat-tab label="Features">
                                <mat-tab-group>
                                  <mat-tab label="Property">
                                    <div class="container-fluid">
                                      <div class="row">
                                        <div class="col-lg-12">
                                          <h3 class="block">Features</h3>
                                        </div>
                                        <div class="col-lg-12">
                                          <mat-divider class="block mb-5"></mat-divider>
                                        </div>
                                        <div class="col-lg-4">
                                          <mat-slide-toggle class="block" formControlName="elevator">Elevator</mat-slide-toggle>
                                        </div>
                                        <div class="col-lg-4">
                                          <mat-slide-toggle style="flex: 0 0 calc(33% - 10px)" formControlName="disabled">Disabled Access</mat-slide-toggle>
                                        </div>
                                        <div class="col-lg-4">
                                          <mat-slide-toggle style="flex: 0 0 calc(33% - 10px)" formControlName="pets">Pets Allowed</mat-slide-toggle>
                                        </div>
                                        <div class="col-lg-12">
                                          <mat-divider class="block my-5"></mat-divider>
                                        </div>
                                        <br>
                                          <div class="col-lg-12">
                                            <h2>Lead Features</h2>
                                            <p>Lead Features are highlighted in the marketing materials and the first text the guest reads. First activate the lead feature. Next, click the row and add the Lead Feature
                                            text in the 'descriptive words' field and press Update.</p>
                                          </div>
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="" [developmentId]="developmentId" featureType="leadFeature" describesType=""></app-feature-list>
                                          </div>
                                          <br><br>
                                          <br><br>
                                          <br><br>
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="Property Type" [developmentId]="developmentId" featureType="propertyType" describesType=""></app-feature-list>
                                          </div>
                                          <br><br>
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="Location" [developmentId]="developmentId" featureType="location" describesType=""></app-feature-list>
                                          </div>
                                          <br><br>
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="Style" [developmentId]="developmentId" featureType="style" describesType=""></app-feature-list>
                                          </div>
                                          <br><br>
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="Theme" [developmentId]="developmentId" featureType="theme" describesType=""></app-feature-list>
                                          </div>
                                          <br><br>
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="Rules" [developmentId]="developmentId" featureType="rules" describesType=""></app-feature-list>
                                          </div>
                                          <br><br>
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="Safety" [developmentId]="developmentId" featureType="safety" describesType=""></app-feature-list>
                                          </div>
                                          <br><br>
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="Pets" [developmentId]="developmentId" featureType="pets" describesType=""></app-feature-list>
                                          </div>
                                          <br><br>
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="Green Things" [developmentId]="developmentId" featureType="green" describesType=""></app-feature-list>
                                          </div>
                                          <br><br>
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="Language" [developmentId]="developmentId" featureType="language" describesType=""></app-feature-list>
                                          </div>
                                          <br><br>
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="Currency" [developmentId]="developmentId" featureType="currency" describesType=""></app-feature-list>
                                          </div>
                                          <br><br>
                                        </div>
                                      </div>
                                    </mat-tab>

                                    <mat-tab label="Concierge">
                                      <div class="container-fluid">
                                        <div class="row">
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="Onsite In Resort/Complex" [developmentId]="developmentId" featureType="onsite" describesType="">
                                            </app-feature-list>
                                            <br><br>
                                          </div>
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="Business" [developmentId]="developmentId" featureType="business" describesType=""></app-feature-list>
                                          </div>
                                          <br><br>
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="Concierge" [developmentId]="developmentId" featureType="concierge" describesType=""></app-feature-list>
                                          </div>
                                          <br><br>
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="Entertainment" [developmentId]="developmentId" featureType="entertainment" describesType="">
                                            </app-feature-list>
                                          </div>
                                          <br><br>
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="Transport" [developmentId]="developmentId" featureType="transport" describesType=""></app-feature-list>
                                          </div>
                                          <br><br>
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="Transport Shuttle" [developmentId]="developmentId" featureType="transportShuttle" describesType="">
                                            </app-feature-list>
                                          </div>
                                          <br><br>
                                        </div>
                                      </div>
                                    </mat-tab>

                                    <mat-tab label="Fitness & Spa">
                                      <div class="container-fluid">
                                        <div class="row">
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="Fitness" [developmentId]="developmentId" featureType="fitness" describesType=""></app-feature-list>
                                          </div>
                                          <br><br>
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="Spa" [developmentId]="developmentId" featureType="spa" describesType=""></app-feature-list>
                                          </div>
                                          <br><br>
                                        </div>
                                      </div>
                                    </mat-tab>

                                    <mat-tab label="Pool & Hotubs">
                                      <div class="container-fluid">
                                        <div class="row">
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="Pool Type" [developmentId]="developmentId" featureType="poolType" describesType=""></app-feature-list>
                                          </div>
                                          <br><br>
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="Pool" [developmentId]="developmentId" featureType="pool" describesType=""></app-feature-list>
                                          </div>
                                          <br><br>
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="Pool Features" [developmentId]="developmentId" featureType="poolFeatures" describesType=""></app-feature-list>
                                          </div>
                                          <br><br>
                                          <div class="col-lg-12">
                                            <app-feature-list class="block" [featuresList]="featuresList" title="Pool Furniture" [developmentId]="developmentId" featureType="poolFurniture" describesType="">
                                            </app-feature-list>
                                          </div>
                                          <br><br>
                                        </div>
                                      </div>

                                    </mat-tab>

                                    <mat-tab label="Nearby">
                                      <div class="col-lg-12">
                                        <app-feature-list class="block" [featuresList]="featuresList" title="Nearby" [developmentId]="developmentId" featureType="nearby" describesType=""></app-feature-list>
                                      </div>
                                      <br><br>
                                      <div class="col-lg-12">
                                        <app-feature-list class="block" [featuresList]="featuresList" title="Rentals" [developmentId]="developmentId" featureType="rentals" describesType=""></app-feature-list>
                                      </div>
                                      <br><br>
                                      <div class="col-lg-12">
                                        <app-feature-list class="block" [featuresList]="featuresList" title="Restaurants" [developmentId]="developmentId" featureType="restaurant" describesType=""></app-feature-list>
                                      </div>
                                      <br><br>
                                      <div class="col-lg-12">
                                        <app-feature-list class="block" [featuresList]="featuresList" title="Sports" [developmentId]="developmentId" featureType="sports" describesType=""></app-feature-list>
                                      </div>
                                      <br><br>
                                      <div class="col-lg-12">
                                        <app-feature-list class="block" [featuresList]="featuresList" title="Tours" [developmentId]="developmentId" featureType="tours" describesType=""></app-feature-list>
                                      </div>
                                      <br><br>

                                    </mat-tab>
                                  </mat-tab-group>
                                </mat-tab>

                                <mat-tab label="Pictures">
                                  <div class="container-fluid">
                                    <div class="row">
                                      <div class="col-lg-12">
                                        <ng-template matTabContent>
                                          <app-property-image-vert-layout [developmentId]="developmentId"></app-property-image-vert-layout>
                                        </ng-template>
                                      </div>
                                    </div>
                                  </div>

                                </mat-tab>

                                <mat-tab label="Reviews">
                                </mat-tab>

                                <mat-tab label="History">
                                  <app-audit-list [auditUrl]="'developments/' + this.developmentId + '/audit'"></app-audit-list>
                                </mat-tab>

                                @if (development?.developmentId) {
                                  <mat-tab label="Tasks">
                                    <app-public-task-list [popupMode]="false" [taskSource]="130" [showFilter]="true" [passedTaskName]="'Development: '+development?.adrDevelopmentName? development?.adrDevelopmentName: ''"  [taskSourceId]="developmentId"></app-public-task-list>
                                  </mat-tab>
                                }
                              </mat-tab-group>
                            </form>
                            <br>
                              <div style="float:right">
                                @if (formAction.includes('add')) {
                                  <button mat-raised-button color="primary" (click)="formAdd()" [disabled]="!form1.valid">Save</button>
                                }
                                @if (formAction.includes('add')) {
                                  <button mat-button type="reset" (click)="this.form1.reset()">Clear</button>
                                }
                                @if (formAction.includes('add')) {
                                  <button mat-button type="button" (click)="routerLocation.back()">Cancel</button>
                                }

                                @if (formAction.includes('edit')) {
                                  <button mat-raised-button color="primary" (click)="formUpdate()" [disabled]="!form1.valid">Update</button>
                                }
                                @if (formAction.includes('edit')) {
                                  <button mat-button type="button" [routerLink]="['/development-view', form1.value.developmentId]">Cancel</button>
                                }

                                @if (formAction.includes('view')) {
                                  <button mat-raised-button color="primary" [routerLink]="['/development-edit', form1.value.developmentId]">Edit</button>
                                }
                                @if (formAction.includes('view')) {
                                  <button mat-button type="button" [routerLink]="['/development-list']">Done</button>
                                }
                                @if (formLoading) {
                                  <img class="pl-3"
		src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
}
</div>
